export { datepickerVariables as datepickerCalendarCellVariables } from './datepickerVariables';
